import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable()
export class TimeServiceMock {
  setUserPreferences = () => {};
  shouldShowLocalTime = () => of(true);
}
